import { RightArrowIcon } from "../../../../utils/SvgComps";
import FormButtonComponent from "../../FormControl/FormButton/FormButtonComponent";
import "./CartBandComponent.scss"

const CartBandComponent = (props) => {

    const {
        tagLine, btnAction, btnName, rightTagLine,
        showTagLine, showBtn, showShareIcon
    } = props;
    
    return (
        <>
        {(showBtn||showTagLine||rightTagLine)?<div className="cart-band-wrapper">
            <div className="container">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex gap-4 align-items-center flex-shape">
                        {showTagLine && 
                        <div className="price-band" dangerouslySetInnerHTML={{
                            __html: tagLine
                        }}></div>}
                            {
                            (showTagLine && rightTagLine) &&
                            <div className="price-band right-band" dangerouslySetInnerHTML={{
                                __html: rightTagLine
                            }}></div>
                        }
                        {showBtn && 
                        <FormButtonComponent 
                            btnName={btnName}
                            leftIcon={''}
                            rightIcon={<RightArrowIcon />}
                            altText={''}
                            btnAction={btnAction}
                            isPrimary={false}
                        />}
                    
                    </div>
                    {showShareIcon && false && 
                    <button type="button" className="reset-btn">
                        <img src="/images/share-b2c-icon.svg" alt="share-icon" />
                    </button>}
                </div>
            </div>
        </div>:""}
        </>
    )
}

export default CartBandComponent